export const FUSE_OPTIONS = {
    keys: ['label', 'value'],
    threshold: 0.3,
    isCaseSensitive: false,
};